import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ReceiptRow } from 'src/features/statistics/types/receiptRow';

const RESOURCE = '/payments/:parkingId/payment-orders/:paymentOrderNumber/digital-receipt/';

type OnlinePaymentReceipt = {
    details: string;
    /** Fiscal document rows, with the print attributes the device was given. */
    rows: ReceiptRow[];
    /** Columns the document is laid out on. */
    chars_per_line: number;
    status: 'queued' | 'issuing' | 'issued' | 'failed' | 'unavailable';
    unique_sale_id: string | null;
    document_number: string | null;
    qr: string | null;
};

interface DTO {
    parkingId: string;
    paymentOrderNumber: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, paymentOrderNumber }: DTO): Promise<OnlinePaymentReceipt> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, paymentOrderNumber }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetOnlinePaymentReceipt };
